// Date oficiale firmă - din Certificatul de Înregistrare
export const COMPANY = {
  name: 'AXIOMA INVESTMENTS S.R.L.',
  cui: '51890752',
  regCom: 'J2025039074006',
  euid: 'ROONRC.J2025039074006',
  sediu: 'Jud. Argeș, Sat Bujoi, Comuna Bogați, Nr. 92',
  caen: '4712 - Comerț cu amănuntul nespecializat, cu vânzare predominantă de produse nealimentare',
  director: 'Iulia Maria Marinescu',
  dataInregistrare: '30.05.2025',
  dataEliberare: '03.06.2025',
  certificat: 'Seria B Nr. 5362455',
  email: 'bojoiu@yahoo.com',
  phone: '+40 773 855 881',
  phoneClean: '40773855881',
  whatsapp: '40773855881',
};
